import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AdminPanel.css";
import { baseurl } from "./CoocpeatHome";

function AdminPanel() {
    const [orders, setOrders] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [products, setProducts] = useState([]);

    const [selectedVendorId, setSelectedVendorId] = useState(""); // vendor id string
    const [selectedVendor, setSelectedVendor] = useState(null); // full vendor object
    const [statusbtn, setStatusbtn] = useState("AllOrders");

    const [vendorname, setVendorname] = useState("");
    const [vendorshopname, setVendorshopname] = useState("");
    const [vendorlocation, setVendorlocation] = useState("");
    const [vendorArea, setVendorArea] = useState("");
    const [vendorprofile, setVendorprofile] = useState("");
    const [deliveryCharge, setDeliveryCharge] = useState(0);

    // Add Product Form States
    const [productName, setProductName] = useState("");
    const [productPrice, setProductPrice] = useState("");
    const [productUnit, setProductUnit] = useState("");
    const [productDescription, setProductDescription] = useState("");
    const [productImage, setProductImage] = useState("");



    // For editing a product
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [editName, setEditName] = useState("");
    const [editPrice, setEditPrice] = useState("");
    const [editUnit, setEditUnit] = useState("");
    const [editDescription, setEditDescription] = useState("");
    const [editImage, setEditImage] = useState("");
    const [editImagePreview, setEditImagePreview] = useState("");
    const [loading, setLoading] = useState(false);


    const token = localStorage.getItem("admin_token");

    const handleVendorImage = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
            setVendorprofile(reader.result); // base64 image
        };

        reader.readAsDataURL(file);
    };

    const handleProductImage = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
            setProductImage(reader.result); // base64 image
        };

        reader.readAsDataURL(file);
    };


    const getAllOrders = async () => {
        try {
            const res = await axios.get(baseurl + "admin/getAllOrders", {
                headers: { Authorization: `Bearer ${token}` },
            });
            const normalized = (res.data.orders || []).map((o) => ({
                ...o,
                id: o.id ?? o._id ?? o.OrderNo,
            }));
            setOrders(normalized);
        } catch (err) {
            console.error("getAllOrders:", err);
        }
    };

    const getVendors = async () => {
        try {
            const res = await axios.get(baseurl + "admin/getVendor", {
                headers: { Authorization: `Bearer ${token}` },
            });

            setVendors(res.data.vendors || []);
        } catch (err) {
            console.error("getVendors:", err);
        }
    };

    const getProducts = async () => {
        try {
            const res = await axios.get(baseurl + "products/getproduct", {
                headers: { Authorization: `Bearer ${token}` },
            });
            setProducts(res.data.products || []);
        } catch (err) {
            console.error("getProducts:", err);
        }
    };


    const AddVendor = async () => {
        try {
            setLoading(true); // show spinner
            const token = localStorage.getItem("admin_token");

            const payload = {
                vendorname,
                vendorshopname,
                vendorlocation,
                vendorArea,
                vendorprofile,
                deliveryCharge
            };

            const response = await axios.post(
                baseurl + "admin/addVendor",
                payload,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            alert("Vendor added successfully!");

            setVendorname("");
            setVendorshopname("");
            setVendorlocation("");
            setVendorArea("");
            setVendorprofile("");
            setDeliveryCharge(0);

            getVendors();
            setStatusbtn("VendorList");

        } catch (error) {
            console.error("AddVendor error:", error);
            alert("Failed to add vendor.");
        } finally {
            setLoading(false); // hide spinner
        }
    };

    const Addproducts = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("admin_token");

            if (!selectedVendorId) {
                alert("Please select a vendor");
                return;
            }

            if (!productName || !productPrice || !productUnit || !productDescription) {
                alert("All fields are required!");
                return;
            }

            const payload = {
                vendorId: selectedVendorId,
                productname: productName,
                productprice: Number(productPrice),
                productUnit: productUnit,
                description: productDescription,
                productimg: productImage || "", // optional image
            };
            //  productname, productprice, discount, productimg, description, vendorId

            const response = await axios.post(
                baseurl + "products/addproduct",
                payload,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            alert("Product added successfully!");

            // Reset values
            setProductName("");
            setProductPrice("");
            setProductUnit("");
            setProductDescription("");
            setProductImage("");

            getProducts();
            setStatusbtn("ViewVendorProducts");

        } catch (error) {
            console.error("Addproducts error:", error);
            alert("Failed to add product.");
        } finally {
            setLoading(false);
        }
    };








    // ----- Order status update -----
    const updateOrderStatus = async (orderId) => {
        try {
            await axios.put(
                baseurl + "admin/updateOrderStatus",
                { id: orderId, status: "Delivered" },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setOrders((prev) =>
                prev.map((o) => (o.id === orderId ? { ...o, status: "Delivered" } : o))
            );
            alert("Order marked as Delivered!");
        } catch (error) {
            console.error("updateOrderStatus:", error);
            alert("Failed to update order status");
        }
    };


    useEffect(() => {
        getVendors();
        getAllOrders();
        getProducts();

    }, []);

    const openVendorProducts = (vendor) => {
        // vendor is full vendor object from vendors array
        setSelectedVendorId(vendor._id ?? vendor.id);
        setSelectedVendor(vendor);
        setStatusbtn("ViewVendorProducts");
    };

    const openEditProduct = (product) => {
        setSelectedProduct(product);
        setEditName(product.productname ?? product.name ?? "");
        setEditPrice(product.productprice ?? product.price ?? "");
        setEditUnit(product.productUnit ?? product.unit ?? "");
        setEditDescription(product.description ?? product.productDescription ?? "");
        setEditImage(product.productimg ?? product.image ?? "");
        setEditImagePreview(product.productimg ?? product.image ?? "");
        setStatusbtn("EditProduct");
    };

    // ----- Image upload handler (converts to base64 for preview) -----
    const handleEditImageUpload = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            setEditImage(reader.result);
            setEditImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
    };

    // ----- Update product API call -----
    const updateProductwithid = async (productId) => {
        try {
            const payload = {
                productname: editName,
                productprice: Number(editPrice),
                description: editDescription,
                productimg: editImage,
            };

            const res = await axios.put(
                baseurl + "products/editproduct/" + productId,
                payload,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // Update local products state
            setProducts((prev) =>
                prev.map((p) => (p._id === productId ? { ...p, ...payload, _id: p._id } : p))
            );

            // If currently viewing vendor products, refresh selectedVendor's products view (filter uses products[])
            alert("Product updated successfully");

            // navigate back to vendor products list
            setStatusbtn("ViewVendorProducts");
        } catch (err) {
            console.error("updateProductwithid:", err);
            alert("Failed to update product");
        }
    };

    const updateVendorStatus = async (vendorId, newStatus) => {
        try {
            const token = localStorage.getItem("admin_token");

            await axios.put(
                baseurl + "admin/updateVendorStatus",
                {
                    vendorId: vendorId,
                    isActive: newStatus,
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // Update UI instantly
            setVendors((prev) =>
                prev.map((v) =>
                    v.id === vendorId || v._id === vendorId
                        ? { ...v, isActive: newStatus }
                        : v
                )
            );

            alert("Vendor status updated!");

        } catch (error) {
            console.error("Failed to update vendor:", error);
            alert("Error updating vendor");
        }
    };


    const vendorProducts = products.filter((p) => {
        return (p.vendorId === selectedVendorId) || (p.vendorId === (selectedVendor?._id || selectedVendor?.id));
    });

    return (
        <div className="admin-layout">
            {/* SIDEBAR */}
            <div className="sidebar">
                <h2 className="logo">Admin Panel</h2>

                <button
                    className={`side-btn ${statusbtn === "AllOrders" ? "active" : ""}`}
                    onClick={() => setStatusbtn("AllOrders")}
                >
                    Orders
                </button>

                <button
                    className={`side-btn ${statusbtn === "VendorList" ? "active" : ""}`}
                    onClick={() => setStatusbtn("VendorList")}
                >
                    Vendors
                </button>

                <button
                    className={`side-btn ${statusbtn === "AddVendor" ? "active" : ""}`}
                    onClick={() => setStatusbtn("AddVendor")}
                >
                    Add Vendor
                </button>

                <button
                    className={`side-btn ${statusbtn === "AddProduct" ? "active" : ""}`}
                    onClick={() => setStatusbtn("AddProduct")}
                >
                    Add Product
                </button>
            </div>

            {/* MAIN */}
            <div className="main">
                {/* All Orders */}
                {statusbtn === "AllOrders" && (
                    <>
                        <h2 className="section-title">All Orders</h2>

                        <div className="table">
                            <div className="table-header">
                                <span>Order ID</span>
                                <span>Name</span>
                                <span>Mobile</span>
                                <span>Product</span>
                                <span>Qty</span>
                                <span>Amount</span>
                                <span>Created</span>
                                <span>Delivery</span>
                                <span>Status</span>
                            </div>

                            <div className="table-body">
                                {orders.map((o) => (
                                    <div className="table-row" key={o.id}>
                                        <span>{o.OrderNo}</span>
                                        <span>{o.customerDetails?.customerName}</span>
                                        <span>{o.customerDetails?.customerMobile}</span>
                                        <span>{o.productName ?? o.products?.[0]?.productName}</span>
                                        <span>{o.quantity ?? o.products?.[0]?.quantity}</span>
                                        <span>₹{o.TotalPaidAmount}</span>

                                        {/* CREATED DATE */}
                                        <span>
                                            {o.createdAt
                                                ? new Date(o.createdAt).toLocaleString("en-IN", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                })
                                                : "-"}
                                        </span>

                                        {/* DELIVERY DATE */}
                                        <span>
                                            {o.deliveryDate
                                                ? new Date(o.deliveryDate).toLocaleDateString("en-IN", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                })
                                                : "Instant"}
                                        </span>

                                        <span>
                                            <button
                                                className="small-btn green"
                                                onClick={() => updateOrderStatus(o.id)}
                                                disabled={(o.status ?? o.orderStatus) === "Delivered"}
                                            >
                                                {(o.status ?? o.orderStatus) === "Delivered"
                                                    ? "Delivered"
                                                    : (o.status ?? o.orderStatus)}
                                            </button>
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                )}


                {/* Vendor List */}
                {statusbtn === "VendorList" && (
                    <>
                        <h2 className="section-title">Vendor List</h2>

                        <div className="table">
                            <div className="table-header">
                                <span>Vendor</span>
                                <span>Shop Img</span>
                                <span>Shop Name</span>
                                <span>Area</span>
                                <span>Status</span>
                                <span>Products</span>
                                <span>Edit</span>
                            </div>

                            <div className="table-body">
                                {vendors.map((v) => (
                                    <div className="table-row" key={v._id}>
                                        <span>{v.vendorname}</span>
                                        <span>
                                            <img
                                                src={v.vendorprofile || v.vendorProfile || "/no-image.png"}
                                                className="thumb"
                                                alt={v.vendorname}
                                            />
                                        </span>
                                        <span>{v.vendorshopname}</span>
                                        <span>{v.vendorArea}</span>
                                        <span>
                                            <button
                                                className="small-btn blue"
                                                onClick={() => updateVendorStatus(v.id, !v.isActive)}
                                            >
                                                {v.isActive ? "Active" : "Inactive"}
                                            </button>
                                        </span>


                                        <span>
                                            <button
                                                className="small-btn blue"
                                                onClick={() => {
                                                    setSelectedVendorId(v._id ?? v.id);
                                                    setSelectedVendor(v); // store whole vendor object
                                                    setStatusbtn("ViewVendorProducts");
                                                }}
                                            >
                                                View Products
                                            </button>
                                        </span>

                                        <span>
                                            <button
                                                className="small-btn gray"
                                                onClick={() => {
                                                    setSelectedVendor(v);
                                                    setSelectedVendorId(v._id ?? v.id);
                                                    setStatusbtn("EditVendor");
                                                }}
                                            >
                                                Edit Vendor
                                            </button>
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                )}

                {/* View Vendor Products (filtered from products array) */}
                {statusbtn === "ViewVendorProducts" && selectedVendor && (
                    <>
                        <h2 className="section-title">Products of {selectedVendor.vendorname}</h2>

                        <div className="table">
                            <div className="table-header">
                                <span>Image</span>
                                <span>Name</span>
                                <span>Price</span>
                                <span>Description</span>
                                <span>Edit</span>
                            </div>

                            <div className="table-body">
                                {vendorProducts.length === 0 && (
                                    <div className="table-row">
                                        <span colSpan={5}>No products for this vendor</span>
                                    </div>
                                )}

                                {vendorProducts.map((p) => (
                                    <div className="table-row" key={p._id}>
                                        <span>
                                            <img src={p.productimg || "/no-image.png"} className="thumb" alt={p.productname} />
                                        </span>
                                        <span>{p.productname}</span>
                                        <span>₹{p.productprice}</span>
                                        <span>
                                            {p.description?.length > 25 ? p.description.substring(0, 25) + "…" : p.description}
                                        </span>

                                        <span>
                                            <button
                                                className="small-btn gray"
                                                onClick={() => openEditProduct(p)}
                                            >
                                                Edit Product
                                            </button>
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <button
                            className="primary-btn"
                            style={{ marginTop: "20px", width: "200px" }}
                            onClick={() => setStatusbtn("VendorList")}
                        >
                            Back
                        </button>
                    </>
                )}

                {/* Edit Product Screen */}
                {statusbtn === "EditProduct" && selectedProduct && (
                    <div className="center-wrapper">
                        <div className="form-card">
                            <h2>Edit Product</h2>

                            <div className="form-group">
                                <label>Product Name</label>
                                <input value={editName} onChange={(e) => setEditName(e.target.value)} />
                            </div>

                            <div className="form-group">
                                <label>Product Price</label>
                                <input
                                    type="number"
                                    value={editPrice}
                                    onChange={(e) => setEditPrice(e.target.value)}
                                />
                            </div>

                            <div className="form-group">
                                <label>Unit (optional)</label>
                                <input value={editUnit} onChange={(e) => setEditUnit(e.target.value)} />
                            </div>

                            <div className="form-group">
                                <label>Description</label>
                                <textarea value={editDescription} onChange={(e) => setEditDescription(e.target.value)} />
                            </div>

                            <div className="form-group">
                                <label>Product Image</label>
                                <input type="file" accept="image/*" onChange={handleEditImageUpload} />
                            </div>

                            {editImagePreview && (
                                <div style={{ marginBottom: 12 }}>
                                    <img src={editImagePreview} alt="preview" style={{ width: "100%", borderRadius: 8, objectFit: "cover" }} />
                                </div>
                            )}

                            <button
                                className="primary-btn"
                                onClick={() => updateProductwithid(selectedProduct.id)}
                            >
                                Save Product
                            </button>

                            <button
                                className="secondary-btn"
                                onClick={() => setStatusbtn("ViewVendorProducts")}
                                style={{ marginTop: 10 }}
                            >
                                Back
                            </button>
                        </div>
                    </div>
                )}

                {/* Edit Vendor (simple prefill) */}
                {statusbtn === "EditVendor" && selectedVendor && (
                    <div className="center-wrapper">
                        <div className="form-card">
                            <h2>Edit Vendor</h2>

                            <div className="form-group">
                                <label>Vendor Name</label>
                                <input defaultValue={selectedVendor.vendorname} />
                            </div>

                            <div className="form-group">
                                <label>Shop Name</label>
                                <input defaultValue={selectedVendor.vendorshopname} />
                            </div>

                            <div className="form-group">
                                <label>Area</label>
                                <input defaultValue={selectedVendor.vendorArea} />
                            </div>

                            <div className="form-group">
                                <label>Profile Image</label>
                                <input type="file" accept="image/*" />
                            </div>

                            <button className="primary-btn">Save Vendor</button>

                            <button
                                className="secondary-btn"
                                onClick={() => setStatusbtn("VendorList")}
                                style={{ marginTop: 10 }}
                            >
                                Back
                            </button>
                        </div>
                    </div>
                )}

                {/* Add Vendor */}
                {statusbtn === "AddVendor" && (
                    <div className="center-wrapper">
                        <div className="form-card">
                            <h2>Add Vendor</h2>

                            <div className="form-group">
                                <label>Vendor Name</label>
                                <input
                                    type="text"
                                    value={vendorname}
                                    onChange={(e) => setVendorname(e.target.value)}
                                    placeholder="Vendor name"
                                />
                            </div>

                            <div className="form-group">
                                <label>Shop Name</label>
                                <input
                                    type="text"
                                    value={vendorshopname}
                                    onChange={(e) => setVendorshopname(e.target.value)}
                                    placeholder="Shop name"
                                />
                            </div>

                            <div className="form-group">
                                <label>Location</label>
                                <input
                                    type="text"
                                    value={vendorlocation}
                                    onChange={(e) => setVendorlocation(e.target.value)}
                                    placeholder="Vendor location"
                                />
                            </div>

                            <div className="form-group">
                                <label>Area</label>
                                <input
                                    type="text"
                                    value={vendorArea}
                                    onChange={(e) => setVendorArea(e.target.value)}
                                    placeholder="Vendor area"
                                />
                            </div>
                            <div className="form-group">
                                <label>Deliverycharge</label>
                                <input
                                    type="text"
                                    value={deliveryCharge}
                                    onChange={(e) => setDeliveryCharge(e.target.value)}
                                    placeholder="Delivery Charge"
                                />
                            </div>

                            <div className="form-group">
                                <label>Profile Image</label>
                                <input type="file" accept="image/*" onChange={handleVendorImage} />
                            </div>

                            <button className="primary-btn" onClick={AddVendor}>
                                Save Vendor
                            </button>

                        </div>
                    </div>
                )}

                {/* Add Product */}
                {statusbtn === "AddProduct" && (
                    <div className="center-wrapper">
                        <div className="form-card">
                            <h2>Add Product</h2>

                            <div className="form-group">
                                <label>Select Vendor</label>
                                <select
                                    value={selectedVendorId}
                                    onChange={(e) => setSelectedVendorId(e.target.value)}
                                >
                                    <option value="">Choose vendor</option>
                                    {vendors.map((v) => (
                                        <option key={v._id} value={v._id}>
                                            {v.vendorname} — {v.vendorshopname}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {selectedVendorId && (
                                <>
                                    <div className="divider-title">Product Details</div>

                                    <div className="form-group">
                                        <label>Product Name</label>
                                        <input
                                            type="text"
                                            value={productName}
                                            onChange={(e) => setProductName(e.target.value)}
                                            placeholder="Enter product name"
                                        />

                                    </div>

                                    <div className="form-group">
                                        <label>Price</label>
                                        <input
                                            type="number"
                                            value={productPrice}
                                            onChange={(e) => setProductPrice(e.target.value)}
                                            placeholder="Enter price"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Unit</label>
                                        <input
                                            type="text"
                                            value={productUnit}
                                            onChange={(e) => setProductUnit(e.target.value)}
                                            placeholder="Ex: 1 KG / 500 g"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Description</label>
                                        <textarea
                                            value={productDescription}
                                            onChange={(e) => setProductDescription(e.target.value)}
                                            placeholder="Short description..."
                                        ></textarea>
                                    </div>

                                    <div className="form-group">
                                        <label>Product Image</label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleProductImage}
                                        />
                                    </div>
                                    <button className="primary-btn" onClick={Addproducts}>
                                        Save Product
                                    </button>

                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default AdminPanel;
